import {
  setIsLoading,
  setBusinessUuid,
  setTokens,
  clearToken
} from './actions';

import {
  requestBusinessUuid,
  requestListTokens
} from './services';

export const loadBusinessUuid = userId => dispatch => {
  dispatch(setIsLoading(true));

  return requestBusinessUuid(userId)
    .then(({ data }) => {
      dispatch(setBusinessUuid(data?.uuid));
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject({});
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const loadTokens = (userId, businessUuid) => dispatch => {
  dispatch(setIsLoading(true));

  return requestListTokens(userId, businessUuid)
    .then(({ data }) => dispatch(setTokens(data || [])))
    .catch(() => dispatch(clearToken()))
    .finally(() => dispatch(setIsLoading(false)));
}